// removed by extract-text-webpack-plugin
module.exports = {"video":"Player-module__video___2R6oo","bottom":"Player-module__bottom___cgKEd"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Player/Player.module.sass
// module id = 1045
// module chunks = 0